import React from 'react';
import "../../style/hero_section.css";
import AboutUs from "../AboutUs_Homepage";
import infoIcon from "../../parm_assets/tree_icons.png";
import isaLogo from "../../parm_assets/about_us/ic_isa.jpg"; // replace with your local image
import safeTreeLogo from "../../parm_assets/parm_logo_2.png"; // replace with your local image

const workerImg = "https://ik.imagekit.io/axiomhives/parm_assets/about_us/WhatsApp%20Image%202026-02-05%20at%209.48.07%20AM.jpeg";

const objectivesData = [
  { id: '01', text: 'To develop, uphold and educate the knowledge of arboriculture in Malaysia.' },
  { id: '02', text: 'To upgrade quality, professionalism and standards of practice in Malaysian arboriculture as of to make the country as an educational reference center in tropical arboriculture services.' },
  { id: '03', text: 'To create Arboriculture Certification in Malaysia [List of \'Certified Arborist 2005-current\']' },
  { id: '04', text: 'To adopt arboriculture knowledge in all tree care related education levels towards creating civil, knowledgeable and skilled society.' },
  { id: '05', text: 'To assist in realization of aspirations of the country towards developing the most beautiful state parks' },
  { id: '06', text: 'To mobilize resources and expertise in establishing conservation and preservation of trees and green areas.' },
];


const AboutHero = () => {

  return (
    <div className="page-container">

      {/* 2. ABOUT US HERO SECTION */}
      <section className="about-hero-section">
        <div className="about-hero-content">
          <h1 className="about-page-title">About Us</h1>
          <nav className="breadcrumb">
            <span className="breadcrumb-item">Home</span>
            <span className="breadcrumb-separator"> &gt; </span>
            <span className="breadcrumb-item active">About Us</span>
          </nav>
        </div>
      </section>

      {/* 3. SECTION BELOW */}
      <section className="about-section">
            <div className="about-container">
              {/* Left Section */}
              <div className="about-left">
                <div className="image-grid">
                  <img src={workerImg} alt="Tree Worker" className="main-img" />
                  <div className="badge">
                    <h2>21</h2>
                    <p>Years Of<br />Association</p>
                  </div>
                  <img src={isaLogo} alt="ISA Logo" className="isa-img" />
                  <img src="https://ik.imagekit.io/axiomhives/parm_assets/Logo_-_PARM__pokok_bulat_.jpg-removebg-preview.png" alt="Safe Tree Logo" className="safe-img" />
                </div>
              </div>
      
              {/* Right Section */}
              <div className="about-right">
                <p className="about-tag">
                  <img src={infoIcon} alt="icon" className="about-icon" />
                  ABOUT US
                  </p>
                <h2 className="about-title">
                  Pioneer in Malaysia <br /> Tropical Arboriculture
                </h2>
                <p className="about-desc">
                  Persatuan Arborist Malaysia (PArM) is a non-profit organization that
                  serves as an umbrella body for arboriculture practitioners involved
                  in maintenance and management of urban forest trees. Our members are
                  from multiple backgrounds which include professional members and
                  students passionate about the importance of tree care in the urban
                  landscape. Continuous education programs and expertise topics are
                  promoted and shared through experienced and specialist speakers from
                  ISA Certified Arborist, academicians and researchers from the Forest
                  Research Institute of Malaysia and higher-level institutions in
                  Malaysia. PArM stands for sustainable urban forest landscape.
                </p>
                {/* <button className="read-btn">
                  Read More <span className="arrow">→</span>
                </button> */}
      
                <div className="vision-mission">
                  <div className="vm-card">
                    <div className="vm-header">
                      <div className="circle"></div>
                      <h3>VISION</h3>
                    </div>
                    <p>Pioneer in Malaysia Tropical Arboriculture.</p>
                  </div>
      
                  <div className="vm-card">
                    <div className="vm-header">
                      <div className="circle"></div>
                      <h3>MISSION</h3>
                    </div>
                    <p>
                      To uplift professionalism in the field of arboriculture and to
                      inculcate public awareness regarding tree benefits and functions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

      <section className="objectives-aboutus-section">
      <div className="container-aboutus">
        
        {/* Header Section */}
        <div className="header-content-aboutus">
          <span className="eyebrow-aboutus">
            <img src={infoIcon} alt="icon" className="tree-icon" />
            OUR OBJECTIVE</span>
          <h2 className="main-title-aboutus">PArM's Objective</h2>
        </div>

        <div className="objectives-grid-aboutus">
          {objectivesData.map((item) => (
            <div key={item.id} className="objective-card-aboutus">
              <span className="card-number-aboutus">{item.id}</span>
              <p className="card-text-aboutus">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    </div>
  );
};

export default AboutHero;